// extracted by mini-css-extract-plugin
export default {"popularHeader":"_1i5h6oiZ","mobile":"mobile","popularTitle":"lVXHdYLA","searchWrapper":"qjoJbiTf","searchTitle":"YiuNDzhJ"};